/**
 * Sidebar Navigation (desktop, md+). Sections come from `nav/nav-config.ts`.
 */

import { Settings } from 'lucide-react';

import { cn } from '@/lib/utils';
import { SidebarBrandBar } from '@/components/layouts/sidebar-easter-egg';

import { NavItemLink, NavSections, SETTINGS_HREF, useActiveNavHref } from './nav';

const SETTINGS_ITEM = { labelKey: 'items.settings', href: SETTINGS_HREF, icon: Settings };

export function Sidebar({ collapsed = false }: { collapsed?: boolean }) {
  const activeHref = useActiveNavHref();
  return (
    <aside className={cn('hidden flex-shrink-0 border-r bg-card md:block transition-[width] duration-200', collapsed ? 'w-16' : 'w-64')}>
      <div className="flex h-full flex-col">
        <SidebarBrandBar collapsed={collapsed} />
        <nav className={cn('sidebar-nav-hide-scrollbar flex-1 min-h-0 overflow-y-auto', collapsed ? 'p-2' : 'p-4')}>
          <NavSections collapsed={collapsed} />
        </nav>
        <div className={cn('border-t', collapsed ? 'p-2' : 'p-4')}>
          <NavItemLink item={SETTINGS_ITEM} active={activeHref === SETTINGS_HREF} collapsed={collapsed} />
        </div>
      </div>
    </aside>
  );
}
